import styled from "styled-components";
import AppInfo from "./AppInfo";
import { containerStyle } from "./styles";
import DataredeDriverImage from "./DataredeDriverImage";
import DataredeLogoImage from "./DataredeLogoImage";
import { BannerProps, ContainerComponentProps } from ".";

const BannerLargeDevices = ({ data }: BannerProps) => {
  return (
    <Container backgroundSrc={data.background.path}>
      <DataredeDriverContainer>
        <DataredeDriverImage />
      </DataredeDriverContainer>
      <DataredeLogoContainer>
        <DataredeLogoImage image={data.logo} />
      </DataredeLogoContainer>
      <ContentWrapper>
        <StyledAppInfo data={data} />
      </ContentWrapper>
    </Container>
  );
};

export default BannerLargeDevices;

const Container = styled.div<ContainerComponentProps>`
  ${({ backgroundSrc }) => containerStyle(backgroundSrc)}
`;

const DataredeDriverContainer = styled.div`
  width: 50vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    max-width: 700px;
    width: 40vw;
    height: 40vw;

    img {
      width: 100%;
      height: auto;
    }
  }
`;

const DataredeLogoContainer = styled.div`
  position: absolute;
  top: 5vh;
  right: 5vh;
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 50vw;
  display: flex;
`;

const StyledAppInfo = styled(AppInfo)`
  max-width: 550px;
  margin-top: 25vh;
  margin-left: 8vw;

  @media (max-width: 1400px) {
    margin-left: 5vw;
    font-size: 13px;
  }
`;
